export const pages = {
  calendar: 'Calendario',
  patients_list: 'Pazienti',
  registry: 'Anagrafica',
  medicalHistory: 'Dati Clinici',
  aiFeatures: 'Funzioni AI',
  documents: 'Documenti Paziente',
  lifeLine: 'Linea di Vita',
  modules: 'Documenti',
  invoices: 'Fatture',
  invoices_billing_data: 'I Miei Dati',
  invoices_list: 'Fatture Emesse',
  invoices_received: 'Fatture Ricevute',
  invoices_sales: 'Fatturato',
  client_list: 'Elenco Clienti',
  aiAnalyses: 'Analisi AI',
  interviewDetails: 'Interview Details',
};

export const classes = {
  nhnb: 'noHighlightedNoBig',
  //nhnb: 'highlightedNoBig',
  hnb: 'highlightedNoBig',
  hb: 'highlightedBig',
  nhb: 'noHighlightedBig',
};

export const labelsWithBottomSeparator = [
  'Analisi AI',
  'Documenti',
  'Pazienti',
  'Calendario',
];
